import { openDB } from "idb";

const DB_NAME = "palm3";

export async function initDB() {
  return openDB(DB_NAME, 6, {
    upgrade(db) {
      // Criar store para jogos
      if (!db.objectStoreNames.contains("jogos")) {
        db.createObjectStore("jogos", { keyPath: "id", autoIncrement: true });
      }

      // Criar store para jogadores
      if (!db.objectStoreNames.contains("jogadores")) {
        const jogadoresStore = db.createObjectStore("jogadores", {
          keyPath: "id",
          autoIncrement: true,
        });
        // ✅ Adiciona índice único para id_fixo
        jogadoresStore.createIndex("id_fixo", "id_fixo", { unique: true });
      }

      // Criar store para o Time 1
      if (!db.objectStoreNames.contains("time1")) {
        db.createObjectStore("time1", { keyPath: "id", autoIncrement: true });
      }

      // Criar store para o Time 2
      if (!db.objectStoreNames.contains("time2")) {
        db.createObjectStore("time2", { keyPath: "id", autoIncrement: true });
      }

      // Criar store para os Próximos Reservas
      if (!db.objectStoreNames.contains("proxReservas")) {
        db.createObjectStore("proxReservas", {
          keyPath: "id",
          autoIncrement: true,
        });
      }

      // Criar store para a contagem de vitórias dos times
      if (!db.objectStoreNames.contains("teamVictories")) {
        db.createObjectStore("teamVictories", { keyPath: "teamId" });
      }

      // Criar store para goleiros
      if (!db.objectStoreNames.contains("goleiros")) {
        db.createObjectStore("goleiros", { keyPath: "timeId" });
      }
    },
  });
}

export async function getTeamVictories(teamId) {
  const db = await initDB();
  return db.get("teamVictories", teamId);
}

export async function setTeamVictories(teamId, victories) {
  const db = await initDB();
  return db.put("teamVictories", { teamId, victories });
}

export async function incrementTeamVictory(teamId) {
  const db = await initDB();
  const currentVictories = (await getTeamVictories(teamId)) || {
    teamId,
    victories: 0,
  };
  currentVictories.victories++;
  return db.put("teamVictories", currentVictories);
}

export async function resetTeamVictory(teamId) {
  const db = await initDB();
  return db.put("teamVictories", { teamId, victories: 0 });
}

export async function decrementTeamVictory(teamId) {
  const db = await initDB();
  const currentVictories = (await getTeamVictories(teamId)) || {
    teamId,
    victories: 0,
  };
  if (currentVictories.victories > 0) {
    currentVictories.victories--;
  }
  return db.put("teamVictories", currentVictories);
}

export async function addJogo(jogo) {
  const db = await initDB();
  const jogoComId = jogo && jogo.id ? jogo : { id: 1, ...jogo }; // permite definir ID customizado
  return db.put("jogos", jogoComId); // Salva no store "jogos"
}

export async function getDadosJogo() {
  const db = await initDB();
  return db.getAll("jogos"); // Busca do store "jogos"
}

export async function addJogador(jogador) {
  const db = await initDB();
  return db.put("jogadores", jogador); // Salva no store "jogadores"
}

export async function getJogadores() {
  const db = await initDB();
  return db.getAll("jogadores"); // Busca do store "jogadores"
}

export async function getJogadoresTime1() {
  const db = await initDB();
  return db.getAll("time1");
}

export async function getJogadoresTime2() {
  const db = await initDB();
  return db.getAll("time2");
}

export async function removeJogador(id) {
  const db = await initDB();
  return db.delete("jogadores", id); // Remove do store "jogadores"
}

export async function clearStore(storeName) {
  const db = await initDB();
  const tx = db.transaction(storeName, "readwrite");
  const store = tx.objectStore(storeName);
  await store.clear();
  await tx.done;
}

export async function saveInStore(storeName, items) {
  const db = await initDB();
  const tx = db.transaction(storeName, "readwrite");
  const store = tx.objectStore(storeName);
  for (const item of items) {
    await store.put(item);
  }
  await tx.done;
}

// Substituir funções específicas por chamadas às utilitárias
export async function clearTime1() {
  return clearStore("time1");
}
export async function clearTime2() {
  return clearStore("time2");
}
export async function clearProxReservas() {
  return clearStore("proxReservas");
}
export async function clearGoleiros() {
  return clearStore("goleiros");
}
export async function saveTime1(time1) {
  return saveInStore("time1", time1);
}

export async function saveTime2(time2) {
  return saveInStore("time2", time2);
}

export async function saveProxReservas(proxReservas) {
  return saveInStore("proxReservas", proxReservas);
}

export async function clearJogoAtivo() {
  return clearStore("jogos");
}

export async function vitoriaTime1(maxVictories, jogadoresPorTime) {
  const db = await initDB();

  // Incrementa a vitória do Time 1 e zera a do Time 2
  await incrementTeamVictory("time1");
  await resetTeamVictory("time2");

  const currentVictoriesTime1 = await getTeamVictories("time1");

  if (maxVictories > 0 && currentVictoriesTime1.victories >= maxVictories) {
    // Se o Time 1 atingiu o máximo de vitórias, ele vai para as reservas
    const time1 = await db.getAll("time1");
    const proxReservas = await db.getAll("proxReservas");

    const txProxReservasClear = db.transaction("proxReservas", "readwrite");
    const storeProxReservasClear =
      txProxReservasClear.objectStore("proxReservas");
    await storeProxReservasClear.clear();
    await txProxReservasClear.done;

    const novasReservas = [...proxReservas, ...time1];

    const txProxReservasUpdate = db.transaction("proxReservas", "readwrite");
    const storeProxReservasUpdate =
      txProxReservasUpdate.objectStore("proxReservas");

    let id = 1;
    for (const jogador of novasReservas) {
      const { isGoleiro, ...restanteJogador } = jogador;
      const jogadorComId = { ...restanteJogador, id: id++ };
      await storeProxReservasUpdate.put(jogadorComId);
    }
    await txProxReservasUpdate.done;

    const txTime1 = db.transaction("time1", "readwrite");
    const storeTime1 = txTime1.objectStore("time1");
    await storeTime1.clear();
    await txTime1.done;

    // Reseta as vitórias do Time 1, pois ele foi para as reservas
    await resetTeamVictory("time1");
    // Incrementa a vitória do Time 2, pois ele permaneceu em campo
    await incrementTeamVictory("time2");

    return "time1"; // Retorna o time que precisa ser preenchido
  } else {
    // Caso contrário, o Time 2 (perdedor) vai para as reservas
    const time2 = await db.getAll("time2");
    const proxReservas = await db.getAll("proxReservas");

    const txProxReservasClear = db.transaction("proxReservas", "readwrite");
    const storeProxReservasClear =
      txProxReservasClear.objectStore("proxReservas");
    await storeProxReservasClear.clear();
    await txProxReservasClear.done;

    const novasReservas = [...proxReservas, ...time2];

    const txProxReservasUpdate = db.transaction("proxReservas", "readwrite");
    const storeProxReservasUpdate =
      txProxReservasUpdate.objectStore("proxReservas");

    let id = 1;
    for (const jogador of novasReservas) {
      const { isGoleiro, ...restanteJogador } = jogador;
      const jogadorComId = { ...restanteJogador, id: id++ };
      await storeProxReservasUpdate.put(jogadorComId);
    }
    await txProxReservasUpdate.done;

    const txTime2 = db.transaction("time2", "readwrite");
    const storeTime2 = txTime2.objectStore("time2");
    await storeTime2.clear();
    await txTime2.done;

    return "time2"; // Retorna o time que precisa ser preenchido
  }
}

export async function vitoriaTime2(maxVictories, jogadoresPorTime) {
  const db = await initDB();

  // Incrementa a vitória do Time 2 e zera a do Time 1
  await incrementTeamVictory("time2");
  await resetTeamVictory("time1");

  const currentVictoriesTime2 = await getTeamVictories("time2");

  if (maxVictories > 0 && currentVictoriesTime2.victories >= maxVictories) {
    // Se o Time 2 atingiu o máximo de vitórias, ele vai para as reservas
    const time2 = await db.getAll("time2");
    const proxReservas = await db.getAll("proxReservas");

    const txProxReservasClear = db.transaction("proxReservas", "readwrite");
    const storeProxReservasClear =
      txProxReservasClear.objectStore("proxReservas");
    await storeProxReservasClear.clear();
    await txProxReservasClear.done;

    const novasReservas = [...proxReservas, ...time2];

    const txProxReservasUpdate = db.transaction("proxReservas", "readwrite");
    const storeProxReservasUpdate =
      txProxReservasUpdate.objectStore("proxReservas");

    let id = 1;
    for (const jogador of novasReservas) {
      const { isGoleiro, ...restanteJogador } = jogador;
      const jogadorComId = { ...restanteJogador, id: id++ };
      await storeProxReservasUpdate.put(jogadorComId);
    }
    await txProxReservasUpdate.done;

    const txTime2 = db.transaction("time2", "readwrite");
    const storeTime2 = txTime2.objectStore("time2");
    await storeTime2.clear();
    await txTime2.done;

    // Reseta as vitórias do Time 2, pois ele foi para as reservas
    await resetTeamVictory("time2");
    // Incrementa a vitória do Time 1, pois ele permaneceu em campo
    await incrementTeamVictory("time1");

    return "time2"; // Retorna o time que precisa ser preenchido
  } else {
    // Caso contrário, o Time 1 (perdedor) vai para as reservas
    const time1 = await db.getAll("time1");
    const proxReservas = await db.getAll("proxReservas");

    const txProxReservasClear = db.transaction("proxReservas", "readwrite");
    const storeProxReservasClear =
      txProxReservasClear.objectStore("proxReservas");
    await storeProxReservasClear.clear();
    await txProxReservasClear.done;

    const novasReservas = [...proxReservas, ...time1];

    const txProxReservasUpdate = db.transaction("proxReservas", "readwrite");
    const storeProxReservasUpdate =
      txProxReservasUpdate.objectStore("proxReservas");

    let id = 1;
    for (const jogador of novasReservas) {
      const { isGoleiro, ...restanteJogador } = jogador;
      const jogadorComId = { ...restanteJogador, id: id++ };
      await storeProxReservasUpdate.put(jogadorComId);
    }
    await txProxReservasUpdate.done;

    const txTime1 = db.transaction("time1", "readwrite");
    const storeTime1 = txTime1.objectStore("time1");
    await storeTime1.clear();
    await txTime1.done;

    return "time1"; // Retorna o time que precisa ser preenchido
  }
}

// Função para lidar com a rotação de jogadores em caso de empate
export async function handleDrawRotation(jogadoresPorTime) {
  const db = await initDB();

  // 1. Recuperar os jogadores atuais
  const time1 = await db.getAll("time1");
  const time2 = await db.getAll("time2");
  const proxReservas = await db.getAll("proxReservas");

  // 2. Sortear aleatoriamente qual time vai para trás primeiro
  const ordemAleatoria = Math.random();
  let jogadoresParaRotacao = [];

  if (ordemAleatoria < 0.5) {
    // Reservas atuais + Time 1 + Time 2
    jogadoresParaRotacao = [...proxReservas, ...time1, ...time2];
  } else {
    // Reservas atuais + Time 2 + Time 1
    jogadoresParaRotacao = [...proxReservas, ...time2, ...time1];
  }

  // 3. Limpar todos os stores
  await clearTime1();
  await clearTime2();
  await clearProxReservas();

  // Zera a contagem de vitórias de ambos os times
  await resetTeamVictory("time1");
  await resetTeamVictory("time2");

  // 4. Re-atribuir IDs sequenciais e redistribuir os jogadores da nova fila de rotação
  let idCounter = 1;
  const jogadoresComNovosIds = jogadoresParaRotacao.map((jogador) => {
    const { isGoleiro, ...restanteJogador } = jogador;
    return {
      ...restanteJogador,
      id: idCounter++,
    };
  });

  const qtdPorTime = jogadoresPorTime;

  // Preencher Time 1
  const newTime1 = jogadoresComNovosIds.splice(0, qtdPorTime);
  await saveTime1(newTime1);

  // Preencher Time 2
  const newTime2 = jogadoresComNovosIds.splice(0, qtdPorTime);
  await saveTime2(newTime2);

  // Preencher Reservas com o restante
  await saveProxReservas(jogadoresComNovosIds);
}

// Função para lidar com a rotação de jogadores quando ambos os times saem
export async function ambosSaemRotation(timeVencedor, jogadoresPorTime) {
  const db = await initDB();

  // 1. Recuperar os jogadores atuais
  const time1 = await db.getAll("time1");
  const time2 = await db.getAll("time2");
  const proxReservas = await db.getAll("proxReservas");

  // 2. Montar a nova lista de reservas com o time vencedor na frente
  let novaListaReservas = [];
  if (timeVencedor === "time1") {
    novaListaReservas = [...proxReservas, ...time1, ...time2];
  } else {
    novaListaReservas = [...proxReservas, ...time2, ...time1];
  }

  // 3. Limpar todos os stores
  await clearTime1();
  await clearTime2();
  await clearProxReservas();

  // 4. Re-atribuir IDs sequenciais e redistribuir os jogadores da nova fila de rotação
  let idCounter = 1;
  const jogadoresComNovosIds = novaListaReservas.map((jogador) => {
    const { isGoleiro, ...restanteJogador } = jogador;
    return {
      ...restanteJogador,
      id: idCounter++,
    };
  });

  // 5. Preencher Time 1
  const newTime1 = jogadoresComNovosIds.splice(0, jogadoresPorTime);
  await saveTime1(newTime1);

  // 6. Preencher Time 2
  const newTime2 = jogadoresComNovosIds.splice(0, jogadoresPorTime);
  await saveTime2(newTime2);

  // 7. Preencher Reservas com o restante
  await saveProxReservas(jogadoresComNovosIds);

  // 8. Zerar a contagem de vitórias de ambos os times
  await resetTeamVictory("time1");
  await resetTeamVictory("time2");
}

// Função genérica para atualizar um time com os primeiros jogadores da lista de proxReservas
export async function atualizarTimeComReservas(nomeTime, jogadoresPorTime) {
  const db = await initDB();

  // Passo 1: Recuperar a lista de proximosReservas
  const proxReservas = await db.getAll("proxReservas");
  const qtdPorTime = jogadoresPorTime;

  // Passo 2: Selecionar os primeiros jogadores da lista para o Time
  const novosJogadores = proxReservas.slice(0, qtdPorTime);
  const novasReservas = proxReservas.slice(qtdPorTime); // Remove os primeiros jogadores da lista de reservas

  // Passo 3: Limpar o time especificado e adicionar os novos jogadores
  const txTime = db.transaction(nomeTime, "readwrite");
  const storeTime = txTime.objectStore(nomeTime);
  await storeTime.clear(); // Limpa todos os jogadores do time especificado
  for (const jogador of novosJogadores) {
    await storeTime.put(jogador); // Adiciona os novos jogadores no time
  }
  await txTime.done;

  // Passo 4: Atualizar o proxReservas com os jogadores restantes
  const txProxReservas = db.transaction("proxReservas", "readwrite");
  const storeProxReservas = txProxReservas.objectStore("proxReservas");
  await storeProxReservas.clear(); // Limpa as reservas
  for (const jogador of novasReservas) {
    await storeProxReservas.put(jogador); // Reinsere os jogadores restantes nas reservas
  }
  await txProxReservas.done;
}

export async function getJogadoresProxReservas() {
  const db = await initDB();
  return db.getAll("proxReservas"); // Retorna todos os jogadores da store 'proxReservas'
}

// Goleiros
export async function getGoleiros() {
  const db = await initDB();
  const goleiros = await db.getAll("goleiros");
  const inicial = { time1: null, time2: null };
  return goleiros.reduce((acc, item) => {
    if (item?.timeId === "time1") acc.time1 = item.jogador || null;
    if (item?.timeId === "time2") acc.time2 = item.jogador || null;
    return acc;
  }, inicial);
}

export async function getGoleiro(timeId) {
  const db = await initDB();
  const registro = await db.get("goleiros", timeId);
  return registro?.jogador || null;
}

export async function setGoleiro(timeId, jogador) {
  const db = await initDB();
  const tx = db.transaction("goleiros", "readwrite");
  await tx.objectStore("goleiros").put({ timeId, jogador });
  await tx.done;
}

const sanitizarJogadorParaReserva = (jogador) => {
  if (!jogador) return null;
  const { id, isGoleiro, ...resto } = jogador;
  return { ...resto };
};

export async function definirGoleiroAPartirDaReserva(timeId, reservaId) {
  const db = await initDB();
  const tx = db.transaction(["proxReservas", "goleiros"], "readwrite");
  const reservasStore = tx.objectStore("proxReservas");
  const goleirosStore = tx.objectStore("goleiros");

  const jogadorReserva = await reservasStore.get(reservaId);
  if (!jogadorReserva) {
    await tx.done;
    return { sucesso: false, motivo: "reserva_nao_encontrada" };
  }

  const goleiroAtual = await goleirosStore.get(timeId);
  if (goleiroAtual?.jogador) {
    const jogadorDevolvido = sanitizarJogadorParaReserva(goleiroAtual.jogador);
    await reservasStore.add(jogadorDevolvido);
  }

  await reservasStore.delete(reservaId);

  const novoGoleiro = { ...jogadorReserva, isGoleiro: true };
  await goleirosStore.put({ timeId, jogador: novoGoleiro });
  await tx.done;
  return { sucesso: true, goleiro: novoGoleiro };
}

export async function removerGoleiroParaReservas(timeId) {
  const db = await initDB();
  const tx = db.transaction(["proxReservas", "goleiros"], "readwrite");
  const reservasStore = tx.objectStore("proxReservas");
  const goleirosStore = tx.objectStore("goleiros");

  const goleiroAtual = await goleirosStore.get(timeId);
  if (!goleiroAtual?.jogador) {
    await tx.done;
    return null;
  }

  await goleirosStore.delete(timeId);

  const jogadorDevolvido = sanitizarJogadorParaReserva(goleiroAtual.jogador);
  const novoId = await reservasStore.add(jogadorDevolvido);
  await tx.done;

  return { ...jogadorDevolvido, id: novoId };
}

// ✅ NOVA FUNÇÃO: Busca otimizada de jogador por id_fixo
export async function getJogadorPorIdFixo(id_fixo) {
  const db = await initDB();
  const tx = db.transaction("jogadores", "readonly");
  const store = tx.objectStore("jogadores");
  const jogador = await store.get(id_fixo);
  await tx.done;
  return jogador;
}

// ✅ NOVA FUNÇÃO: Atualização otimizada de múltiplos jogadores por id_fixo
export async function atualizarMultiplosJogadoresPorIdFixo(atualizacoes) {
  /*
  atualizacoes: [
    { id_fixo: "uuid-1", campo: "vitorias", valor: 1 },
    { id_fixo: "uuid-2", campo: "empates", valor: 1 }
  ]
  */

  const db = await initDB();
  const tx = db.transaction("jogadores", "readwrite");
  const store = tx.objectStore("jogadores");

  for (const atualizacao of atualizacoes) {
    const jogador = await store.get(atualizacao.id_fixo);
    if (!jogador) continue;

    jogador[atualizacao.campo] = (jogador[atualizacao.campo] || 0) + atualizacao.valor;
    await store.put(jogador);
  }

  await tx.done;
}

// Função para adicionar jogador ao final da lista de proxReservas
export async function addJogadorAosReservas(jogador) {
  const db = await initDB();
  const tx = db.transaction("proxReservas", "readwrite");
  const store = tx.objectStore("proxReservas");
  await store.add(jogador); // Adiciona o jogador ao final da lista
  await tx.done;
}

// Função para atualizar um jogador nas tabelas 'jogadores' do IndexedDB
export async function updateJogador(jogador) {
  const db = await initDB();
  const txProxReservas = db.transaction("proxReservas", "readwrite");
  const storeProxReservas = txProxReservas.objectStore("proxReservas");
  await storeProxReservas.put(jogador);
  await txProxReservas.done;
}

export async function updateJogadorPorIdFixo(jogadorParcial) {
  const db = await initDB();
  const tx = db.transaction("jogadores", "readwrite");
  const store = tx.objectStore("jogadores");

  const jogadorOriginal = await store.get(jogadorParcial.id_fixo);

  if (!jogadorOriginal) {
    console.warn(`Jogador com id_fixo ${jogadorParcial.id_fixo} não encontrado`);
    return;
  }

  const jogadorAtualizado = {
    ...jogadorOriginal,
    vitorias: (jogadorOriginal.vitorias || 0) + 1,
  };

  await store.put(jogadorAtualizado);
  await tx.done;
}

export async function incrementarEmpatesDosTimes() {
  const db = await initDB();

  const [time1, time2] = await Promise.all([
    db.getAll("time1"),
    db.getAll("time2"),
  ]);
  const todosJogadores = [...time1, ...time2];

  const atualizacoes = [];
  for (const jogador of todosJogadores) {
    if (!jogador?.id_fixo) continue;
    atualizacoes.push({ id_fixo: jogador.id_fixo, campo: "empates", valor: 1 });
    atualizacoes.push({
      id_fixo: jogador.id_fixo,
      campo: "qt_partidas",
      valor: 1
    });
  }
  if (atualizacoes.length > 0) {
    await atualizarMultiplosJogadoresPorIdFixo(atualizacoes);
  }
}

// Função para excluir um jogador da tabela 'proxReservas' no IndexedDB
export async function deleteJogador(id) {
  const db = await initDB();
  const tx = db.transaction("proxReservas", "readwrite");
  const store = tx.objectStore("proxReservas");
  await store.delete(id); // Exclui o jogador com o ID especificado
  await tx.done;
}

export async function clearAllData() {
  const db = await initDB();
  // Itera sobre todas as stores (tabelas) e as limpa
  const storeNames = db.objectStoreNames;
  for (let i = 0; i < storeNames.length; i++) {
    const storeName = storeNames[i];
    const tx = db.transaction(storeName, "readwrite");
    const store = tx.objectStore(storeName);
    await store.clear(); // Limpa todos os dados da store atual
    await tx.done;
  }
}

// Função para substituir um jogador no time, trocando apenas os nomes no IndexedDB
export async function substituirJogadorNoDB(jogadorId, reservaId, time) {
  const db = await initDB();

  try {
    // Passo 1: Obter o jogador da reserva
    let txReservas = db.transaction("proxReservas", "readonly");
    let storeReservas = txReservas.objectStore("proxReservas");
    const jogadorReserva = await storeReservas.get(reservaId);

    // Passo 2: Obter o jogador do time selecionado
    const txTime = db.transaction(time, "readwrite");
    const storeTime = txTime.objectStore(time);
    const jogadorTime = await storeTime.get(jogadorId);

    // Salva os nomes para troca
    const nomeReserva = jogadorReserva.nome;
    const nomeJogadorTime = jogadorTime.nome;

    // Passo 3: Alterar o nome do jogadorTime para o nome do jogadorReserva
    jogadorTime.nome = nomeReserva;
    await storeTime.put(jogadorTime);

    // Passo 4: Reabrir a transação para atualizar o jogadorReserva
    txReservas = db.transaction("proxReservas", "readwrite");
    storeReservas = txReservas.objectStore("proxReservas");

    jogadorReserva.nome = nomeJogadorTime;
    await storeReservas.put(jogadorReserva);

    return true; // Indica que a troca de nomes foi bem-sucedida
  } catch (error) {
    console.error("Erro ao trocar nomes dos jogadores no IndexedDB:", error);
    return false;
  }
}

// Função que verificar se existe jogos ativos
export async function hasJogoAtivo() {
  const db = await initDB();
  const jogos = await db.getAll("jogos");
  return jogos.length > 0;
}

// Registra o gol e assistencia dos jogadores
export async function registrarGolEAssistencia(
  jogadorIdGol,
  jogadorIdAssistencia
) {
  // ✅ OTIMIZADO: Usar atualização em lote para melhor performance
  const atualizacoes = [];

  if (jogadorIdGol) {
    atualizacoes.push({
      id_fixo: jogadorIdGol,
      campo: "gols",
      valor: 1
    });
  }

  if (jogadorIdAssistencia) {
    atualizacoes.push({
      id_fixo: jogadorIdAssistencia,
      campo: "assistencias",
      valor: 1
    });
  }

  if (atualizacoes.length > 0) {
    await atualizarMultiplosJogadoresPorIdFixo(atualizacoes);
  }

  return true;
}

// Função para obter o próximo ID disponível para jogadores
export async function getProximoIdJogador() {
  const db = await initDB();
  const jogadores = await db.getAll("jogadores");
  
  // Encontra o maior ID atual e incrementa
  const maxId = jogadores.length > 0 ? Math.max(...jogadores.map(j => j.id || 0)) : 0;
  return maxId + 1;
}
